import { Button, Flex, Form, Input } from "antd";
import { useEffect } from "react";
import CustomDrawer from "../../../../../components/ui/CustomDrawer";
import {
  useCreateLeaveAllocationMutation,
  useUpdateLeaveAllocationMutation,
} from "../../../../../features/organization/contractual/LeaveManagement/leaveManagementApi";
import useError from "../../../../../hooks/useError";
import { toast } from "../../../../../lib/toast";

export default function ManageLeaveType({
  data,
  type,
  open,
  handleClose,
}: {
  data: any;
  type?: string;
  open: boolean;
  handleClose: (value?: boolean) => void;
}) {
  const [form] = Form.useForm();

  const [
    createSlab,
    {
      isLoading: creating,
      isSuccess: created,
      isError: isCreateError,
      error: createError,
    },
  ] = useCreateLeaveAllocationMutation();
  const [
    updateSlab,
    {
      isLoading: updating,
      isSuccess: updated,
      isError: isUpdateError,
      error: updateError,
    },
  ] = useUpdateLeaveAllocationMutation();

  const handleSubmit = (values: any) => {
    if (type === "ADD") {
      createSlab(values);
    } else {
      updateSlab({ data: values, id: data?.id });
    }
  };

  const handleDrawerClose = () => {
    handleClose();
    form.resetFields();
  };

  // ------ Effects ------
  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data, form]);

  useEffect(() => {
    if (created) {
      toast("success", "Leave type created successfully.");
      handleClose();
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [created]);

  useEffect(() => {
    if (updated) {
      toast("success", "Leave type updated successfully.");
      handleClose();
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updated]);

  // ------ Errors ------
  useError(isCreateError, createError, "Leave type create failed.");
  useError(isUpdateError, updateError, "Leave type update failed.");

  return (
    <>
      <CustomDrawer
        width={460}
        open={open}
        onClose={() => {
          handleClose();
          form.resetFields();
        }}
        title={type === "ADD" ? "Add New Leave type" : "Edit Leave type"}
      >
        <Form
          form={form}
          size="large"
          layout="vertical"
          requiredMark="optional"
          className="custom-form"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="leave_name"
            label="Leave Name"
            className="mb-4"
            rules={[{ required: true, message: "Please enter leave name" }]}
          >
            <Input placeholder="Enter leave name" />
          </Form.Item>

          {/* Number of Seats */}
          <Form.Item
            name="total_days"
            label="Total Days"
            className="mb-4"
            rules={[
              { required: true, message: "Please enter total days" },
              {
                validator: (_, value) => {
                  if (value !== undefined && value !== null) {
                    const num = Number(value);
                    if (!Number.isInteger(num)) {
                      return Promise.reject("Total Days cannot be decimal");
                    }
                    if (num < 0) {
                      return Promise.reject("Total Days cannot be negative");
                    }
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="Ex: 1" type="number" />
          </Form.Item>

          <Flex align="center" gap={16} className="mt-6">
            <Button
              size="middle"
              htmlType="button"
              className="min-w-[120px] h-10"
              onClick={() => handleDrawerClose()}
            >
              Cancel
            </Button>
            <Button
              size="middle"
              htmlType="submit"
              type="primary"
              color="primary"
              loading={creating || updating}
              className="min-w-[120px] h-10"
            >
              {type === "ADD" ? "Save" : "Update"}
            </Button>
          </Flex>
        </Form>
      </CustomDrawer>
    </>
  );
}
